import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '~/redux-toolkit/store/hooks';
import { useLeadActions } from '~/hooks/useLeadActions';
import { useIsUsedCar } from '~/hooks/useIsUsedCar';
import RESOURCES from '~/resources';
import { IUserDetails } from '~/data/lead/interfaces';
import { setLeadDetails } from '~/redux-toolkit/slices/contactUsSlice';
import { setProductSf } from '~/redux-toolkit/slices/usedCarSlice';
import { RootState } from '~/redux-toolkit/store/store';

export const useContactUsLeadBannerProps = () => {
  const dispatch = useAppDispatch();
  const isUsedCar = useIsUsedCar();
  const { isProcessingLead, createLeadRequest } = useLeadActions();

  const { usedBranches } = useAppSelector((state) => state.ourBranches);
  const { screen, campaignNumber, subMedia, note, usedCarContactUs } =
    useAppSelector((state) => state.contactUsSlice);
  const { usedCar } = useAppSelector((state: RootState) => state.usedCarSlice);
  const request = useCallback(
    async (details: IUserDetails) => {
      if (isUsedCar) {
        dispatch(setProductSf(usedCar.productSfid));
        createLeadRequest(details, {
          campaignNumber,
          subMedia,
          products: [
            usedCar.productSfid || usedCarContactUs?.productSfid || '',
          ],
          note,
        });
      } else {
        createLeadRequest(details, {
          campaignNumber,
          subMedia,
          note,
        });
      }

      dispatch(setLeadDetails(details));
    },
    [
      isUsedCar,
      dispatch,
      createLeadRequest,
      campaignNumber,
      subMedia,
      note,
      usedCar,
      usedCarContactUs,
    ],
  );

  return {
    buttonLabel: RESOURCES.SEND_LEAD_DETAILS_BUTTON,
    loading: isProcessingLead,
    onSubmit: request,
    cities: isUsedCar && screen !== 'lobby' ? usedBranches : undefined,
    brands: undefined, // Add brandsDropdownDetails logic if needed
  };
};
